export const VERIFY_SIGN_IN_WITH_SLACK_PATH = 'verify-sign-in-with-slack';
export const VERIFY_SIGN_IN_WITH_SLACK_URL =
  `${window.location.origin}/${VERIFY_SIGN_IN_WITH_SLACK_PATH}`;

export const VERIFY_ADD_TO_SLACK_PATH = 'verify-add-to-slack';
export const VERIFY_ADD_TO_SLACK_URL =
  `${window.location.origin}/${VERIFY_ADD_TO_SLACK_PATH}`;



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/